import React, {useEffect,useRef} from 'react';

const Typing = (props) =>{

    const textArr = props.textArr;
    const heading = useRef(null);
    const subheading = useRef(null);
    
    const isSubText = (props.isSubtext === "true" ? true : false);
    var i = 0,
        j = 0,
        clearText = false;

    function typing(){
        var element = heading.current,
            text = textArr[j];
        if(!element){
            return false;
        }
        if(!clearText){
            if(i < text.length){
                if(text.charAt(i) === "|"){
                    subheading.current.innerHTML = text.split("|")[1];
                    subheading.current.classList = "fade-in";
                    clearText = true;
                    setTimeout(function(){ typing() }, 2000);
                }else{
                    if(text.charAt(i) === '-'){
                        element.innerHTML = element.innerHTML + '<br/>';
                    }else{
                        element.innerHTML = element.innerHTML + text.charAt(i);
                    }                    
                    i++;
                    setTimeout(function(){ typing() }, 100);
                }
            }else if(i === text.length){
                clearText = true;                
                setTimeout(function(){ typing() }, 2000);
            }
        }else{
            if(isSubText){ subheading.current.classList = "fade-out"; }            
            if(element.innerText.length > 0){
                element.innerText = element.innerText.substring(0, element.innerText.length - 1);
                setTimeout(function(){ typing() }, 25);
            }else{                
                i=0;
                clearText=false;
                j = (j + 1) % textArr.length;
                setTimeout(function(){ typing() }, 50);
            }
        }         
     }
    useEffect(() => {
        heading.current.innerHTML = "";
        // subheading.current.innerHTML = "";
        typing();        
    }, []);
    
    return(
        <div >
            <h3 ref={heading} className="typing">&nbsp;</h3>            
            {isSubText &&
                <h6 ref={subheading}>&nbsp;</h6>
            }           
        </div>
    )
}

export default Typing;